import { UPDP_BUYBOX_MODES } from "rtr-constants";

export const getPDPBuyboxMode = (pdpUrl?: string, merchandisingCategory?: string, reserveDate?: string) => {
  const params = new URLSearchParams(pdpUrl ?? "");
  if (merchandisingCategory === "Clearance") {
    return UPDP_BUYBOX_MODES.CLEARANCE;
  } else if (params.has("buynow") && params.get("buynow") === "true") {
    return UPDP_BUYBOX_MODES.BUY;
  } else if (reserveDate) {
    return UPDP_BUYBOX_MODES.RESERVE;
  } else {
    return UPDP_BUYBOX_MODES.MEMBERSHIP;
  }
};
